<template>
	<div class="admin-body">
		<div class="topheader">
			<p class="title">利德后台管理</p>
			<el-button type="info" class="s" @click="LoginOut">退出</el-button>
		</div>
		<div class="contentwrap">
			<div class="leftmenu">
				<Menu active-name="1" width="150px">
					<MenuItem name="1" to="/adminhome">
					<Icon size="20" type="md-contact" />
					审核查看
					</MenuItem>

					<MenuItem name="2" to="/baseset" class="mybaseline">
					<Icon size="20" type="ios-folder-open" />
					基础管理
					</MenuItem>
					<MenuItem name="3" to="/wholesaler" class="mybaseline">
					<Icon size="20" type="ios-folder-open" />
					客户列表
					</MenuItem>
					<MenuItem name="4" to='/Reviewed' class="mybaseline">
					<Icon size="20" type="ios-folder-open" />
					数据库列表
					</MenuItem>
					<MenuItem name="5" to='/WX' class="mybaseline">
					<Icon size="20" type="ios-folder-open" />
					小程序列表
					</MenuItem>
				</Menu>
			</div>

			<div class="rightbox">
				<keep-alive>
					<router-view />
				</keep-alive>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {};
		},
		methods: {
			LoginOut() {
				localStorage.clear()
				this.$store.commit('loginout')
				this.$router.replace('/adminlogin')
			}
		}
	};
</script>

<style lang="less" scoped>
	@top_height: 65px;

	.admin-body {
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		flex-direction: column;

		.topheader {
			width: 100%;
			height: @top_height;
			position: fixed;
			z-index: 99;
			background: #202020;
			top: 0;
			left: 0;
			display: flex;
			align-items: center;

			.title {
				font-size: 26px;
				margin-left: 15px;
				color: @head_fontcolor;
				font-weight: bold;
			}
		}

		.contentwrap {
			width: 100%;
			height: calc(100% - @top_height);
			margin-top: @top_height;
			//background: #00FFFF;
			display: flex;

			.leftmenu {
				height: 100vh;
				position: fixed;
				z-index: 99;
				left: 0;

				.ivu-menu {
					height: 100%;
					background: #202020;
					color: @head_fontcolor;

					.ivu-menu-item-selected {
						background: #505050;
						color: #ccc;
					}
				}
			}

			.rightbox {
				display: flex;
				width: calc(100vw - 170px);
				height: 100%;
				margin-left: 150px;
				overflow-y: scroll;
				padding-bottom: 150px;
				//background: #1890FF;
			}
		}
	}

	.s {
		position: relative;
		right: -1150px;
	}
</style>
